import {CopyToClipboard} from 'react-copy-to-clipboard';
import {useDispatch} from 'react-redux';
import {resetPayPalLinks} from '../../../../reducers/app/actions';
import {useNavigate} from 'react-router-dom';
import Support from '../../../components/support';

export default ({data, links, onPayment}) => {
    const dispatch = useDispatch(),
          navigate = useNavigate();

    return (
        <>
            <Support />
            <div className="page-title">PayPal</div>
            <div className="page-descriptions">
                Click «<b>Open payment link</b>» to go to the payment page. After making the payment, click «<b>Payment made</b>»
            </div>

            <div className="paypal_sender">
                <div className="value" style={{color: "#fff"}}>{data.name}</div>
                <div className="label">Sender name</div>
            </div>

            <div className="amount_input paypal">
                <div className="amount">
                    <div className="symbol">$</div>
                    <div className="value">{data.amount}</div>
                </div>
                <div className="label">Selected amount</div>
            </div>

            <div className="mt10"></div>
            {/* <div className="button green" onClick={e => window.open(`https://cash.app/$phnXO69/50.00`, '_blank')}>Open CashApp for payment</div> */}
            {links[data.amount.toString()] !== 'undefined' && (
                <div className="button paypal" onClick={() => window.open(links[data.amount.toString()], '_blank')}>Open payment link</div>
            )}

            <div className="mt20"></div>
            <div className="button blue" onClick={e => {
                onPayment();
            }}>Payment made</div>

            <div className="button" onClick={e => {
                dispatch(resetPayPalLinks());
                navigate('/');
            }}>Cancel payment</div>
        </>
    )
}